import styled from 'styled-components';
import { pickThemeColor, pickThemeFontSize, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  max-width: 40rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  align-self: flex-start;
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  background-color: ${pickThemeColor('BG_SECONDARY')};

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const StyledActionButton = styled.div`
  cursor: pointer;

  .anticon {
    font-size: ${pickThemeFontSize('24')};
    color: ${pickThemeColor('ORANGE_PRIMARY')};

    svg {
      fill: none;
    }
  }
`;

export const StyledDeleteButton = styled.div`
  cursor: pointer;
  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const StyledDescription = styled.div`
  color: ${pickThemeColor('GREY')};
  ${pickThemeFontStyles('14', '22')};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
